export enum TemplateCarType {
    List = 'list',
    Wizard = 'wizard',
    Inline = 'inline',
    WizardX = 'wizardx',
    WizardT = 'wizardt',
    GateWay = 'gateway',
    InlineX = 'inlinex',
    Overflow = 'overflow',
}